/*
 * Photo gallery arrows on a review card (snippets/bh-review-card.liquid).
 *
 * Lives in an asset rather than the reviews-wall section's {% javascript %} block because the
 * card is used by two sections now — the wall on the reviews page and the rail on the PDP — and
 * a section's javascript only loads with that section. The arrows rendered on the PDP and did
 * nothing until this moved out.
 *
 * Guarded so loading it from both sections on one page cannot double-bind.
 */
if (!window.__bhReviewCardGallery) {
  window.__bhReviewCardGallery = true;

    // One delegated listener for the whole wall rather than a pair per card — there can be 100+
    // galleries on this page. Wraps at the ends so an arrow always does something; with two or
    // three photos that reads better than an arrow that looks broken.
    document.addEventListener("click", (event) => {
      const button = event.target.closest(".bh-wall__nav");
      if (!button) return;

      const track = button.parentElement.querySelector(".bh-wall__photos");
      if (!track) return;

      const step = track.clientWidth;
      const atEnd = track.scrollLeft + step >= track.scrollWidth - 1;
      const atStart = track.scrollLeft <= 1;

      if (button.dataset.dir === "next") {
        // scrollTo, not scrollBy, for the wrap — scroll-snap corrects the rest.
        if (atEnd) track.scrollTo({ left: 0 });
        else track.scrollBy({ left: step });
      } else if (atStart) {
        track.scrollTo({ left: track.scrollWidth });
      } else {
        track.scrollBy({ left: -step });
      }
    });
}

/*
 * "Покажи повече" on rail cards (clamp: true in bh-review-card.liquid). The button is rendered
 * hidden and only shown when the 4-line clamp actually cuts the text, so short reviews get no
 * dead link. Expands in place; the card grows, the row's other cards keep their size.
 */
if (!window.__bhReviewCardMore) {
  window.__bhReviewCardMore = true;
  const measure = () => document.querySelectorAll('.bh-wall__more').forEach((btn) => {
    const card = btn.closest('.bh-wall__card');
    const text = card && card.querySelector('.bh-wall__text');
    if (!text || card.classList.contains('is-expanded')) return;
    btn.hidden = text.scrollHeight <= text.clientHeight + 1;
  });
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.bh-wall__more');
    if (!btn) return;
    const card = btn.closest('.bh-wall__card');
    const open = card.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? btn.dataset.lessText : btn.dataset.moreText;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure);
  else measure();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure); // web font changes line breaks
  window.addEventListener('resize', measure);
}
